Object.defineProperty(exports,"__esModule",{value:true});var _partialRight2=require("lodash/partialRight");var _partialRight3=_interopRequireDefault(_partialRight2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _victoryCore=require("victory-core");




var _helperMethods=require("./helper-methods");var _helperMethods2=_interopRequireDefault(_helperMethods);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var fallbackProps={
width:450,
height:300,
padding:50};


var defaultData=[
{x:1,y:1,errorX:0.1,errorY:0.1},
{x:2,y:2,errorX:0.2,errorY:0.2},
{x:3,y:3,errorX:0.3,errorY:0.3},
{x:4,y:4,errorX:0.4,errorY:0.4}];


var animationWhitelist=[
"data","domain","height","padding","samples",
"style","width","errorX","errorY","borderWidth"];var


VictoryErrorBar=function(_React$Component){_inherits(VictoryErrorBar,_React$Component);function VictoryErrorBar(){_classCallCheck(this,VictoryErrorBar);return _possibleConstructorReturn(this,(VictoryErrorBar.__proto__||Object.getPrototypeOf(VictoryErrorBar)).apply(this,arguments));}_createClass(VictoryErrorBar,[{key:"renderData",value:function renderData(

























































































































props){var _this2=this;var
dataComponent=props.dataComponent,labelComponent=props.labelComponent,groupComponent=props.groupComponent;

var dataComponents=this.dataKeys.map(function(_dataKey,index){
var dataProps=_this2.getComponentProps(dataComponent,"data",index);
return _react2.default.cloneElement(dataComponent,dataProps);
});

var labelComponents=this.dataKeys.map(function(_dataKey,index){
var labelProps=_this2.getComponentProps(labelComponent,"labels",index);
if(labelProps.text!==undefined&&labelProps.text!==null){
return _react2.default.cloneElement(labelComponent,labelProps);
}
}).filter(Boolean);

var children=[].concat(_toConsumableArray(dataComponents),_toConsumableArray(labelComponents));
return this.renderContainer(groupComponent,children);
}},{key:"shouldAnimate",value:function shouldAnimate()

{
return!!this.props.animate;
}},{key:"renderContainer",value:function renderContainer(

component,children){
var isContainer=component.type&&component.type.role==="container";
var parentProps=isContainer?this.getComponentProps(component,"parent","parent"):{};
return _react2.default.cloneElement(component,parentProps,children);
}},{key:"render",value:function render()

{var
role=this.constructor.role;
var props=_victoryCore.Helpers.modifyProps(this.props,fallbackProps,role);
if(this.shouldAnimate()){
return(
_react2.default.createElement(_victoryCore.VictoryTransition,{animate:props.animate,animationWhitelist:animationWhitelist},
_react2.default.createElement(this.constructor,props)));


}
var children=this.renderData(props);
return this.renderContainer(props.containerComponent,children);
}}]);return VictoryErrorBar;}(_react2.default.Component);VictoryErrorBar.displayName="VictoryErrorBar";VictoryErrorBar.role="errorBar";VictoryErrorBar.defaultTransitions=_victoryCore.DefaultTransitions.discreteTransitions();VictoryErrorBar.propTypes={animate:_react.PropTypes.object,borderWidth:_react.PropTypes.number,categories:_react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.string),_react.PropTypes.shape({x:_react.PropTypes.arrayOf(_react.PropTypes.string),y:_react.PropTypes.arrayOf(_react.PropTypes.string)})]),containerComponent:_react.PropTypes.element,data:_react.PropTypes.array,domainPadding:_react.PropTypes.oneOfType([_react.PropTypes.shape({x:_react.PropTypes.oneOfType([_react.PropTypes.number,_victoryCore.PropTypes.domain]),y:_react.PropTypes.oneOfType([_react.PropTypes.number,_victoryCore.PropTypes.domain])}),_react.PropTypes.number]),dataComponent:_react.PropTypes.element,domain:_react.PropTypes.oneOfType([_victoryCore.PropTypes.domain,_react.PropTypes.shape({x:_victoryCore.PropTypes.domain,y:_victoryCore.PropTypes.domain})]),errorX:_react.PropTypes.oneOfType([_react.PropTypes.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_react.PropTypes.string,_react.PropTypes.arrayOf(_react.PropTypes.string)]),errorY:_react.PropTypes.oneOfType([_react.PropTypes.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_react.PropTypes.string,_react.PropTypes.arrayOf(_react.PropTypes.string)]),events:_react.PropTypes.arrayOf(_react.PropTypes.shape({target:_react.PropTypes.oneOf(["data","labels","parent"]),eventKey:_react.PropTypes.oneOfType([_react.PropTypes.array,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_react.PropTypes.string]),eventHandlers:_react.PropTypes.object})),eventKey:_react.PropTypes.oneOfType([_react.PropTypes.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_react.PropTypes.string]),groupComponent:_react.PropTypes.element,height:_victoryCore.PropTypes.nonNegative,horizontal:_react.PropTypes.bool,labels:_react.PropTypes.oneOfType([_react.PropTypes.func,_react.PropTypes.array]),labelComponent:_react.PropTypes.element,name:_react.PropTypes.string,padding:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.shape({top:_react.PropTypes.number,bottom:_react.PropTypes.number,left:_react.PropTypes.number,right:_react.PropTypes.number})]),samples:_victoryCore.PropTypes.nonNegative,scale:_react.PropTypes.oneOfType([_victoryCore.PropTypes.scale,_react.PropTypes.shape({x:_victoryCore.PropTypes.scale,y:_victoryCore.PropTypes.scale})]),sharedEvents:_react.PropTypes.shape({events:_react.PropTypes.array,getEventState:_react.PropTypes.func}),sortKey:_react.PropTypes.oneOfType([_react.PropTypes.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_react.PropTypes.string,_react.PropTypes.arrayOf(_react.PropTypes.string)]),standalone:_react.PropTypes.bool,style:_react.PropTypes.shape({parent:_react.PropTypes.object,data:_react.PropTypes.object,labels:_react.PropTypes.object}),theme:_react.PropTypes.object,width:_victoryCore.PropTypes.nonNegative,x:_react.PropTypes.oneOfType([_react.PropTypes.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_react.PropTypes.string,_react.PropTypes.arrayOf(_react.PropTypes.string)]),y:_react.PropTypes.oneOfType([_react.PropTypes.func,_victoryCore.PropTypes.allOfType([_victoryCore.PropTypes.integer,_victoryCore.PropTypes.nonNegative]),_react.PropTypes.string,_react.PropTypes.arrayOf(_react.PropTypes.string),_react.PropTypes.arrayOf(_react.PropTypes.func)])};VictoryErrorBar.defaultProps={data:defaultData,scale:"linear",standalone:true,dataComponent:_react2.default.createElement(_victoryCore.ErrorBar,null),labelComponent:_react2.default.createElement(_victoryCore.VictoryLabel,null),containerComponent:_react2.default.createElement(_victoryCore.VictoryContainer,null),groupComponent:_react2.default.createElement("g",{role:"presentation"}),theme:_victoryCore.VictoryTheme.grayscale};VictoryErrorBar.getDomain=_helperMethods2.default.getDomain.bind(_helperMethods2.default);VictoryErrorBar.getData=_victoryCore.Data.getData.bind(_victoryCore.Data);VictoryErrorBar.getBaseProps=(0,_partialRight3.default)(_helperMethods2.default.getBaseProps.bind(_helperMethods2.default),fallbackProps);VictoryErrorBar.expectedComponents=["dataComponent","labelComponent","groupComponent","containerComponent"];exports.default=


(0,_victoryCore.addEvents)(VictoryErrorBar);


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/victory-errorbar/victory-errorbar.js
// module id = 1356
// module chunks = 0